import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalsService } from '../../services/globals.service';
import { normalizeTransactionGlLines, TransactionGlLine } from '../../models/transaction-gl.model';

export interface TransactionGlModalData {
	title: string;
	lines: TransactionGlLine[] | null | undefined;
	/** Systype id + transno; used to refetch after editing a line */
	documentTypeId?: string | number;
	documentTransno?: string | number;
}

@Component({
	selector: 'app-transaction-gl-modal',
	templateUrl: './transaction-gl-modal.component.html',
	styleUrls: ['./transaction-gl-modal.component.scss'],
})
export class TransactionGlModalComponent implements OnInit {
	debitTotal = 0;
	creditTotal = 0;
	hasLines = false;

	constructor(
		public dialogRef: MatDialogRef<TransactionGlModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: TransactionGlModalData,
		private globalsService: GlobalsService
	) {}

	ngOnInit(): void {
		this.applyLines(this.data?.lines);
	}

	onLineSaved(): void {
		const t = this.data?.documentTransno;
		const ty = this.data?.documentTypeId;
		if (t === null || t === undefined || t === '' || ty === null || ty === undefined) {
			return;
		}
		this.globalsService.getTransactionGl(t, ty).subscribe({
			next: (r: { data?: TransactionGlLine[] | null }) => {
				this.data.lines = r?.data ?? [];
				this.applyLines(this.data.lines);
			},
		});
	}

	private applyLines(raw: TransactionGlLine[] | null | undefined): void {
		const n = normalizeTransactionGlLines(raw);
		this.hasLines = n.length > 0;
		this.debitTotal = n.reduce((s, r) => s + r.debit, 0);
		this.creditTotal = n.reduce((s, r) => s + r.credit, 0);
	}

	close(): void {
		this.dialogRef.close();
	}
}
